import api from '@/services/axios/api';
import { AxiosResponse } from 'axios';
import { GesObraModel } from '@/models/gestao/ges-obra.model';
import { SegUsuarioModel } from '@/models/seguranca/seg-usuario.model';
import { DataSource } from 'consulte-framework-vue/components/grid';
import { GesObraSelectionModel } from '@/models/gestao/ges-obra-selection.model';
import TextoValor from '@/models/texto-valor';
import { InvitationModel } from '@/models/identity-server/Invitation.model';
import { GesRegionalSelectionModel } from '@/models/gestao/ges-regional-selection.model';
import SegUsuarioDataSource from '@/datasources/seguranca/seg-usuario/index.datasource';
import { SegGrupoUsuarioItemPermissaoModel } from '@/models/seguranca/seg-grupo-usuario-item-permissao.model';
import { SegUsuarioObrasRegionaisModel } from '@/models/seguranca/seg-usuario-obras-regionais.model';
import SegUsuarioObraDataSource from '@/datasources/seguranca/seg-usuario-obra/index.datasource';

class UserService {
  getCodigoContrato(): Promise<AxiosResponse<number>> {
    return api.get('/user/GetContrato');
  }
  getObrasAcessoUsuario(): Promise<AxiosResponse<GesObraModel[]>> {
    return api.get('/gesobra/ListByUsuario');
  }
  getContratosAcessoUsuario(lazyImages: boolean = false): Promise<AxiosResponse<TextoValor[]>> {
    return api.get(`/user/GetContratos?lazyImages=${lazyImages}`);
  }

  async getSegUsuarioByToken(): Promise<SegUsuarioModel> {
    return (await api.get<SegUsuarioModel>('/segusuario/GetUserByEmail')).data;
  }

  async getPermissoesSegUsuario(): Promise<SegGrupoUsuarioItemPermissaoModel[]> {
    return (await api.get('/segusuario/GetPermissoes')).data;
  }

  async carregarRegistro(segUsuarioId: number): Promise<SegUsuarioModel> {
    return (await api.get<SegUsuarioModel>('/segusuario/' + segUsuarioId)).data;
  }

  async dropDownList(): Promise<TextoValor[]> {
    return (await api.get<TextoValor[]>('/segusuario/DropDownList')).data;
  }

  dadosIndexPaginado(datasource: SegUsuarioDataSource): Promise<AxiosResponse<DataSource<SegUsuarioModel>>> {
    return api.post<DataSource<SegUsuarioModel>>('/segUsuario/Paginado', datasource);
  }

  dadosUsuarioObraPaginado(datasource: SegUsuarioObraDataSource, segUsuarioId: number): Promise<AxiosResponse<DataSource<GesObraSelectionModel>>> {
    return api.post<DataSource<GesObraSelectionModel>>('/segUsuario/PaginadoUsuarioObra/' + segUsuarioId, datasource);
  }
  inserir(usuario: SegUsuarioModel): Promise<AxiosResponse> {
    return api.post('/segUsuario', usuario);
  }

  remover(id: number): Promise<AxiosResponse> {
    return api.delete('/segUsuario/' + id);
  }

  atualizar(usuario: SegUsuarioModel): Promise<AxiosResponse> {
    return api.put('/segUsuario', usuario);
  }

  async obterAcessosUsuario(segUsuarioId: number): Promise<SegUsuarioObrasRegionaisModel> {
    return (await api.get<SegUsuarioObrasRegionaisModel>(`/segUsuario/ObterAcessosUsuario/${segUsuarioId}`)).data;
  }

  addDeleteObra(segUsuarioId: number, usuarioObra: GesObraSelectionModel): Promise<AxiosResponse> {
    return api.put('/segUsuario/AddDeleteObra/' + segUsuarioId, usuarioObra);
  }

  addDeleteRegionais(segUsuarioId: number, usuarioRegionais: GesRegionalSelectionModel): Promise<AxiosResponse> {
    return api.put('/segUsuario/AddDeleteRegional/' + segUsuarioId, usuarioRegionais);
  }

  async getRolesIdentityServer(): Promise<any> {
    return (await api.get<any>('/segusuario/GetRolesIdentityServer')).data;
  }

  inviteUser(user: InvitationModel): Promise<any> {
    return api.post<any>('/segusuario/SendInvitationLink', user);
  }
  acessaTodasObras(segUsuarioId: number): Promise<AxiosResponse<void>> {
    return api.get<void>(`/segusuario/AcessaTodasObras/${segUsuarioId}`);
  }
  verificaUsuarioIntegrado(): Promise<AxiosResponse> {
    return api.post<DataSource<GesObraSelectionModel>>('/segUsuario/IntegraUsuario');
  }
  exportExcel(dataSource: SegUsuarioDataSource, nomeArquivo: string): Promise<AxiosResponse> {
    return api.post<DataSource<SegUsuarioModel>>(`/SegUsuario/ExportarExcel?nomeArquivo=${nomeArquivo}`, dataSource);
  }
  atualizarObrasRegionais(usuario: SegUsuarioObrasRegionaisModel): Promise<AxiosResponse> {
    return api.put('/segUsuario/AtualizarObrasRegionais', usuario);
  }

  createUserOpenId(usuario: any, segUsuarioId: number): Promise<AxiosResponse> {
    return api.post('/segUsuario/CreateUserIdentityServer/' + segUsuarioId, usuario);
  }

  sendCreatedUserEmail(email: any): Promise<AxiosResponse> {
    return api.post('/segUsuario/SendemailCreatedUserAsync/' + email);
  }
}
export default new UserService();
